export const isSameOrAfter = (dateA, dateB) => {
  return dateA.getTime() >= new Date(dateB).getTime()
}

export const isSameOrBefore = (dateA, dateB) => {
  return dateA.getTime() <= new Date(dateB).getTime()
}

export const diffMonth = (dateA, dateB) => {
  const years = dateA.getFullYear() - dateB.getFullYear()
  const months = dateA.getMonth() - dateB.getMonth()
  let totalMonths = years * 12 + months

  // Ajusta se o dia de dateA for menor que o dia de dateB
  if (dateA.getDate() < dateB.getDate()) {
    totalMonths -= 1
  }
  return totalMonths
}

export const diffYear = (dateA, dateB) => {
  return dateA.getFullYear() - dateB.getFullYear()
}

export const diff = (dateA, dateB, unit) => {
  const dA = new Date(dateA)
  const dB = new Date(dateB)
  const msDiff = dA.getTime() - dB.getTime()

  const formattersDate = {
    years: () => diffYear(dA, dB),
    months: () => diffMonth(dA, dB),
    days: () => Math.floor(msDiff / (1000 * 60 * 60 * 24)),
  }

  if (unit && formattersDate[unit]) {
    return formattersDate[unit]()
  }

  return msDiff
}
